import { MessageBar } from '@fluentui/react-components'
import { useProjectInfo } from '../../../../fetchData/queries/useProjectInfo'
import styles from './MessageBars.module.css'

export const InfoBar = () => {
  const projectInfo = useProjectInfo().data
  const isFinalized = projectInfo?.isFinalized
  const isArchived = projectInfo?.isArchived
  const hasBuildStartConsent = projectInfo?.datesInfo?.mgmtBuildStartConsent

  let messages: string[] = []

  if (isArchived) {
    messages.push('Projektet är arkiverat')
  }

  if (isFinalized) {
    messages.push('Projektet är slutredovisat')
  }

  if (!hasBuildStartConsent) {
    messages.push('Igångsättningsmedgivande saknas')
  }

  if (messages.length > 0) {
    return (
      <>
        {messages.map((message, index) => (
          <MessageBar
            key={index}
            intent="warning"
            className={styles.messageBar}
            // style={{ margin: 5, marginBottom: 5, marginTop: 0 }}
            style={{ margin: '0px 5px 5px 5px' }}
          >
            {message}
          </MessageBar>
        ))}
      </>
    )
  }

  return <></>
}
